import React, { useState, useEffect, useRef } from "react";
import FranchiseModal from "../FranchiseMaster/FranchiseModal";
import CustomAlert from "../../../helpers/CustomAlert";
import { toast } from "react-toastify";
import {
  axiosGetApi,
  axiosPostApi,
} from "../../../helpers/interceptorServices";
import { apiList } from "../../../helpers/apiList";
import Loader from "../../../components/Loader/Loader";
import { useDispatch } from "react-redux";
import AddFranchiseTabs from "./AddFranchiseTabs/AddFranchiseTabs";
import FranchiseOnboardingWizard from "./FranchiseOnboardingWizard";
import confetti from "canvas-confetti";
import FranchiseAuditModal from "./FranchiseAuditModal";
import FranchiseFilterModal from "./FranchiseFilterModal";
import ViewFranchiseBalanceModal from "./ViewFranchiseBalanceModal";
import FranchiseOptionsModal from "./FranchiseOptionsModal";
import HeaderWithBreadcrumb from "../../../components/common/HeaderWithBreadcrumb";
import { formatDateToYYYYMMDD } from "../../../helpers/DateHelpers";
import { setBalance } from "../../../components/store/balance/balanceSlice";
import FranchiseUploadDocument from "./FranchiseUploadDocument";
import MasterTable from "../../../components/common/MasterTable";
import FilterBar from "../../../components/common/FilterBar";
import {
  PARTNER_STATUS_OPTIONS,
  asStatusList,
} from "../../../components/common/filterOptions";

const defaultFilterData = {
  franchiseName: "",
  franchiseCode: "",
  gstNumber: "",
  companyPanNumber: "",
  status: [],
  fromDate: "",
  toDate: "",
  primaryContactMobile: "",
  emailId: "",
  search: "",
};

const FranchiseMaster = () => {
  const optionRefs = useRef({});

  // const pageSize = 10;
  const [pageSize, setPageSize] = useState(10);
  const [noData, setNoData] = useState(false);
  const [showModal, setShowModal] = useState(false);
  const [editData, setEditData] = useState({});
  const [customerData, setCustomerData] = useState([]);
  const [modalAction, setModalAction] = useState("");
  const [loading, setLoading] = useState(false);
  const [pageDetails, setPageDetails] = useState(null);
  const loggedInUserName = sessionStorage.getItem("username");
  const [currentPage, setCurrentPage] = useState(1);
  const [auditData, setAuditData] = useState("");
  const [isAuthModalOpen, setIsAuthModalOpen] = useState(false);
  const [filterData, setFilterData] = useState(defaultFilterData);
  const [isOptionsOpen, setIsOptionsOpen] = useState(false);
  const [selectedItem, setSelectedItem] = useState(null);
  const [anchorPosition, setAnchorPosition] = useState({ top: 0, left: 0 });
  const [isViewBalanceModalOpen, setIsViewBalanceModalOpen] = useState(false);
  const [columnData, setColumnData] = useState("");
  const [isUploadModal, setIsUploadModal] = useState(false);

  const dispatch = useDispatch();

  const handleReset = () => {
    setFilterData(defaultFilterData);
  };

  const [authData, setAuthData] = useState(null);

  const [isModalOpenCreate, setIsModalOpenCreate] = useState(false);
  const openModalCreate = () => {
    setIsModalOpenCreate(true);
  };

  const closeModalCreate = () => {
    setIsModalOpenCreate(false);
  };

  const [isModalOpenAudit, setIsModalOpenAudit] = useState(false);
  const openModalAudit = () => {
    setIsModalOpenAudit(true);
  };

  const closeModalAudit = () => {
    setIsModalOpenAudit(false);
  };

  const [isModalOpenFilter, setIsModalOpenFilter] = useState(false);
  const openModalFilter = () => {
    setIsModalOpenFilter(true);
  };

  const closeModalFilter = () => {
    setIsModalOpenFilter(false);
  };

  const handleAuditData = (data) => {
    let custData = customerData.find((item) => item?.id === data?.id);
    console.log("custData", custData);
    fetchFranchiseAudit(custData);
  };

  const fetchFranchiseAudit = async (franchiseData) => {
    setLoading(true);
    try {
      const requestBody = {
        username: loggedInUserName,
        franchiseCode: franchiseData.franchiseCode,
      };

      const response = await axiosPostApi(
        `${apiList.AUDIT_FRANCHISE_DATA}`,
        requestBody
      );

      if (
        response?.data?.status === true &&
        response?.data?.respCode === "00"
      ) {
        setAuditData(response?.data?.data?.auditData);
        openModalAudit(auditData);
        setLoading(false);
      } else {
        setLoading(false);
        CustomAlert({
          title: "Error",
          text: response?.data?.message || "Failed to fetch audit data.",
          icon: "error",
          confirmButtonText: "Retry",
        });
      }
    } catch (error) {
      CustomAlert({
        title: "Error",
        text: "An error occurred while fetching the data. Please try again later.",
        icon: "error",
        confirmButtonText: "Retry",
      });
      setLoading(false);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchFranchiseData(1, filterData);
  }, []);

  const fetchFranchiseData = async (
    currentPage,
    filters = filterData,
    size = pageSize
  ) => {
    setLoading(true);

    try {
      const requestBody = {
        username: loggedInUserName,
        franchiseName: filters.franchiseName || "",
        franchiseCode: filters.franchiseCode || "",
        customerCode: filters.customerCode || "",
        gstNumber: filters.gstNumber || "",
        status: filters.status || [],
        fromDate: formatDate(filters.fromDate),
        toDate: formatDate(filters.toDate),
        companyPanNumber: filters.companyPanNumber || "",
        primaryContactMobile:
          filters.primaryContactMobile ||
          filters.firstContactPersonMobileNo ||
          "",
        firstContactPersonMobileNo:
          filters.firstContactPersonMobileNo ||
          filters.primaryContactMobile ||
          "",
        emailId: filters.emailId || "",
        search: filters.search || "",
      };

      const response = await axiosPostApi(
        `${apiList.FETCH_FRANCHISE_MASTER}?&pageSize=${size}&pageNo=${currentPage}`,
        requestBody
      );
      console.log("FetchCustresponse", response);

      if (
        response?.data?.status === true &&
        response?.data?.respCode === "00"
      ) {
        setLoading(false);

        setPageDetails(response?.data?.pageDetails);
        const modifiedData = modifyStructure(response?.data?.data);
        setCustomerData(modifiedData);
        console.log("Modified customerData:", modifiedData);
        fetchDashboardData();
        if (modifiedData?.length === 0) {
          setNoData(true);
        } else {
          setNoData(false);
        }
      } else {
        setLoading(false);

        setNoData(true);
        setCustomerData([]);
      }
    } catch (error) {
      setLoading(false);

      CustomAlert({
        title: "Error",
        text: "An error occurred while fetching the data. Please try again later.",
        icon: "error",
        confirmButtonText: "Retry",
      });
    } finally {
      setLoading(false);
    }
  };

  const formatDate = (dateStr) => {
    if (!dateStr) return "";
    const [year, month, day] = dateStr.split("-");
    return `${day}-${month}-${year}`;
  };

  const modifyStructure = (response) => {
    return (
      response &&
      response?.map((customer, index) => ({
        ...customer,
        id: index + 1,
        address: customer.addr1 + ", " + customer.addr2 + ", " + customer.addr3,
        mainWalletBalance: customer.mainWalletBalance || 0,
        smsBalance: customer.smsBalance || 0,
        rcsBalance: customer.rcsBalance || 0,
        option: "option",
      }))
    );
  };

  const fetchDashboardData = () => {
    const endDate = formatDateToYYYYMMDD(new Date());
    const startDate1 = new Date(new Date().setDate(new Date().getDate() - 90));
    const finalStartDate = formatDateToYYYYMMDD(startDate1);

    const requestBody = {
      startDate: finalStartDate,
      endDate: endDate,
      username: loggedInUserName,
    };

    // setLoading(true);

    axiosPostApi(apiList.DASHBOARD_DATA, requestBody)
      .then((response) => {
        if (response?.status === 200 && response?.data?.respCode === "00") {
          dispatch(setBalance(response?.data?.data));
        } else {
          // Handle error case here if necessary
        }
      })
      .catch((error) => {
        console.error("Error fetching SMS overview data", error);
      });
  };

  const customerHeader = [
    "Franchise Id",
    "Franchise Name",
    "Franchise Type",
    "Status",
    "Remark",
    "Franchise Email Id",
    "Address",
    "Contact Person Name",
    "Contact Person Mobile No",
    "GST Number",
    "Franchise Pan",
    "PAN Number",
    "Aadhar Number",
    "Option",
  ];

  const customerHeaderToKeyMap = {
    Status: "authStatus",
    Remark: "adminRemark",
    "Franchise Id": "franchiseCode",
    "Franchise Name": "franchiseName",
    "Franchise Type": "franchiseType",
    "Franchise Email Id": "emailId",
    Address: "address",
    "Contact Person Name": "primaryContactName",
    "Contact Person Mobile No": "primaryContactMobile",
    "GST Number": "gstNumber",
    "Franchise Pan": "companyPanNumber",
    "PAN Number": "panNumber",
    "Aadhar Number": "aadharNumber",
  };

  const handleAuthorization = (data) => {
    setAuthData(data);
  };

  const handleAuthSubmit = async (action, remarks) => {
    let status;
    let actionText;

    // Map the action to the correct status code
    switch (action) {
      case "approve":
        status = "1";
        actionText = "authorized";
        break;
      case "block":
        status = "3";
        actionText = "blocked";
        break;
      case "reject":
        status = "5";
        actionText = "rejected";
        break;
      default:
        status = "5";
        actionText = "rejected";
    }

    const requestBody = {
      username: loggedInUserName,
      franchiseCode: authData?.franchiseCode || "",
      status: status,
      adminRemark: remarks || "",
    };

    try {
      const response = await axiosPostApi(
        apiList.AUTH_FRANCHISE_DATA,
        requestBody
      );
      if (response?.status === 200 && response?.data?.respCode === "00") {
        CustomAlert({
          title: "Success",
          text: `Franchise ${actionText} successfully!`,
          icon: "success",
          confirmButtonText: "Ok",
        });

        // Show confetti only for approval
        if (action === "approve") {
          const canvas = document.createElement("canvas");
          canvas.style.position = "fixed";
          canvas.style.top = "0";
          canvas.style.left = "0";
          canvas.style.width = "100%";
          canvas.style.height = "100%";
          canvas.style.zIndex = "3000";
          document.body.appendChild(canvas);

          const confettiInstance = confetti.create(canvas, {
            resize: true,
            useWorker: true,
          });

          confettiInstance({
            particleCount: 250,
            spread: 100,
            origin: { y: 0.6 },
          });

          setTimeout(() => {
            document.body.removeChild(canvas);
          }, 3000);
        }

        fetchFranchiseData(1, filterData); // Pass filterData to maintain filters
      } else {
        CustomAlert({
          title: `Failed to ${actionText} Franchise`,
          text:
            response.data?.message || "Invalid credentials. Please try again!",
          icon: "error",
          confirmButtonText: "Retry",
        });
      }
    } catch (error) {
      console.error(`Error ${actionText} Franchise`, error);
      toast.error(`Failed to ${actionText} Franchise.`);
    }

    setIsAuthModalOpen(false);
    setAuthData(null);
  };

  const handleCloseModal = () => {
    setShowModal(false);
    setEditData({});
    setModalAction("");
  };

  const handleCustomer = (data, actionType = "view") => {
    setModalAction(actionType);
    if (actionType === "add") {
      setEditData({});
      openModalCreate(true);
    } else if (actionType === "auth") {
      let custData = customerData.find((item) => item?.id === data?.id);

      if (custData) {
        setEditData(custData);
        setIsModalOpenCreate(true);
      }
    } else if (actionType === "moreOptions") {
      const custData = customerData.find((item) => item?.id === data?.id);
      const refEl = optionRefs.current[data?.id];

      if (custData && refEl) {
        const rect = refEl.getBoundingClientRect();
        setAnchorPosition({
          top: rect.bottom + window.scrollY + 5,
          left: rect.left + window.scrollX - 120,
        });
        setSelectedItem(custData);
        setIsOptionsOpen(true);
      } else {
        console.warn("Missing DOM reference or data for moreOptions");
      }
    } else if (actionType === "upload") {
      setIsUploadModal(true);
      setColumnData(data);
    } else {
      let custData = customerData.find((item) => item?.id === data?.id);

      if (custData) {
        setEditData(custData);
        openModalCreate(true);
      }
    }
  };

  const handleCloseOptions = () => {
    setIsOptionsOpen(false);
    setSelectedItem(null);
    setAnchorPosition({ top: 0, left: 0 });
  };

  const handleOptionSelect = (option) => {
    console.log("Selected option:", option, "for item:", selectedItem);

    if (option === "View Balance") {
      // Step 1: Close OptionsModal
      setIsOptionsOpen(false);

      // Step 2: Open ViewBalanceModal
      setIsViewBalanceModalOpen(true);

      // You may also want to scroll or focus, depending on UX
      console.log("Opening ViewBalanceModal for item:", selectedItem);
    } else {
      alert(`Selected ${option} for ${selectedItem.name}`);
    }
  };

  const handleCloseViewBalanceModal = () => {
    console.log("Closing ViewBalanceModal");
    setIsViewBalanceModalOpen(false);
  };

  const handleAuthKey = (authData) => {
    CustomAlert({
      title: "SMS Key",
      text: authData.authKey,
      icon: "info",
      confirmButtonText: "Okay",
    });
  };

  const handleRechargeKey = (authData) => {
    CustomAlert({
      title: "Recharge Key",
      text: authData?.rechargeKey || "No recharge key available",
      icon: "info",
      confirmButtonText: "Okay",
    });
  };

  const handlePaymentKey = (authData) => {
    CustomAlert({
      title: "Bill Payment Key",
      text: authData?.billPaymentKey || "No bill payment key available",
      icon: "info",
      confirmButtonText: "Okay",
    });
  };

  const handleCourier = (authData) => {
    CustomAlert({
      title: "Courier Key",
      text: authData?.courierServiceKey || "No courier service key available",
      icon: "info",
      confirmButtonText: "Okay",
    });
  };

  const handleRcsKey = async (authData) => {
    try {
      const response = await axiosGetApi(
        `${apiList.GET_RCS_AGENT_ID}/${authData?.customerCode}`
      );

      const responseData = response?.data?.data || "";
      if (
        response?.data?.status === true &&
        response?.data?.respCode === "00"
      ) {
        CustomAlert({
          title: "RCS Key",
          text: responseData?.rcsAgentId,
          icon: "info",
          confirmButtonText: "Okay",
        });
      } else {
        CustomAlert({
          title: "Error",
          text: response?.data?.message,
          icon: "error",
          confirmButtonText: "Retry",
        });
      }
    } catch (error) {
      CustomAlert({
        title: "Error",
        text: "An error occurred while fetching the data. Please try again later.",
        icon: "error",
        confirmButtonText: "Retry",
      });
    }
  };

  const pageSizeCount = pageDetails === null ? 0 : pageDetails.pageSize;
  const totalRecord = pageDetails === null ? 0 : pageDetails.totalRecords;

  return (
    <>
      <HeaderWithBreadcrumb title="Franchise Master" breadcrumb="Master" />
      <FilterBar
        values={filterData}
        onChange={(next) => {
          setFilterData(next);
          setCurrentPage(1);
          fetchFranchiseData(1, next, pageSize);
        }}
        search={{
          key: "search",
          placeholder: "Search franchise name, code, email, GST or mobile",
        }}
        selects={[
          { key: "status", allLabel: "All statuses", chipLabel: "Status", options: PARTNER_STATUS_OPTIONS, ...asStatusList },
        ]}
        dateRange={{ fromKey: "fromDate", toKey: "toDate", label: "Created" }}
      />
      <div>
        <div className="bg-[#FFFFFF] shadow-custom rounded-[14px] px-[10px]">
          {loading ? (
            <Loader />
          ) : (
            <>
              <MasterTable
                loading={loading}
                headers={customerHeader}
                data={customerData}
                handleAction={handleCustomer}
                handleKey={handleAuthKey}
                RechargeKey={handleRechargeKey}
                BillPaymentKey={handlePaymentKey}
                CourierKey={handleCourier}
                handleRcsKey={handleRcsKey}
                filterFields={["name"]}
                entityType="Franchise"
                headerToKeyMap={customerHeaderToKeyMap}
                handleAuth={handleAuthorization}
                noData={noData}
                pageDetails={pageDetails}
                currentPage={currentPage}
                pageSize={pageSize}
                // pageSize={pageSizeCount}
                totalRecord={totalRecord}
                // fetchNextData={(page) => fetchCustomerData(page, filterData)}
                fetchNextData={(page, size) =>
                  fetchFranchiseData(page, filterData, size)
                }
                setCurrentPage={setCurrentPage}
                setPageSize={setPageSize}
                handleAuditData={handleAuditData}
                openModalFilter={openModalFilter}
                handleReset={handleReset}
                filterData={filterData}
                fetchData={() =>
                  fetchFranchiseData(1, defaultFilterData, pageSize)
                }
                optionRefs={optionRefs}
                hideFilterControls
              />

              <FranchiseModal
                show={showModal}
                handleClose={handleCloseModal}
                editData={editData}
                action={modalAction}
                fetchCustomerData={fetchFranchiseData}
              />
            </>
          )}
        </div>

        {/* Adding a franchise uses the step-by-step flow; edit / view / authorise keep the form */}
        {isModalOpenCreate && modalAction === "add" ? (
          <FranchiseOnboardingWizard
            onClose={closeModalCreate}
            onCreated={() => fetchFranchiseData(1)}
          />
        ) : null}
        {isModalOpenCreate && modalAction !== "add" ? (
          <AddFranchiseTabs
            openCreate={isModalOpenCreate}
            show={openModalCreate}
            CloseCreate={closeModalCreate}
            editData={editData}
            action={modalAction}
            fetchCustomerData={fetchFranchiseData}
          />
        ) : null}

        {isModalOpenFilter ? (
          <FranchiseFilterModal
            show={isModalOpenFilter}
            handleClose={closeModalFilter}
            auditData={auditData}
            setCustomerData={setCustomerData}
            setPageDetails={setPageDetails}
            setNoData={setNoData}
            currentPage={currentPage}
            pageSize={pageSize}
            filterData={filterData}
            setFilterData={setFilterData}
            handleReset={handleReset}
          />
        ) : null}

        {isModalOpenAudit ? (
          <FranchiseAuditModal
            show={isModalOpenAudit}
            handleClose={closeModalAudit}
            auditData={auditData}
          />
        ) : null}

        {isAuthModalOpen && (
          <AuthorizationConfirmationModal
            show={isAuthModalOpen}
            handleClose={() => setIsAuthModalOpen(false)}
            handleSubmit={handleAuthSubmit}
          />
        )}

        {isOptionsOpen && selectedItem && (
          <FranchiseOptionsModal
            open={isOptionsOpen}
            handleClose={handleCloseOptions}
            item={selectedItem}
            anchorPosition={anchorPosition}
            onSelect={handleOptionSelect}
          />
        )}

        {isViewBalanceModalOpen && selectedItem && (
          <ViewFranchiseBalanceModal
            show={isViewBalanceModalOpen}
            handleClose={handleCloseViewBalanceModal}
            item={selectedItem}
          />
        )}

        {isUploadModal && (
          <FranchiseUploadDocument
            show={isUploadModal}
            handleClose={() => setIsUploadModal(false)}
            columnData={columnData}
          />
        )}
      </div>
    </>
  );
};

const AuthorizationConfirmationModal = ({
  show,
  handleClose,
  handleSubmit,
}) => {
  const [action, setAction] = useState("approve");
  const [adminRemark, setRemarks] = useState("");
  const [error, setError] = useState("");

  if (!show) return null;

  const onSubmit = () => {
    if (!adminRemark.trim()) {
      setError("Remark is required");
      return;
    }
    setError("");
    handleSubmit(action, adminRemark);
  };

  const handleRemarkChange = (e) => {
    setRemarks(e.target.value);
    if (error && e.target.value.trim()) {
      setError("");
    }
  };

  return (
    <div
      style={{
        position: "fixed",
        top: 0,
        left: 0,
        width: "100%",
        height: "100%",
        backgroundColor: "rgba(0,0,0,0.5)",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        zIndex: 2000,
      }}
    >
      <div
        style={{
          backgroundColor: "white",
          padding: "50px",
          borderRadius: "40px",
          width: "90%",
          maxWidth: "600px",
          textAlign: "center",
        }}
      >
        <h3 style={{ fontWeight: "bold", fontSize: "24px", color: "#1A202C" }}>
          Are you sure?
        </h3>
        <p
          style={{
            color: "#1A202C",
            fontSize: "18px",
            fontWeight: "normal",
            marginTop: "10px",
          }}
        >
          Do you want to authorize the company?
        </p>

        <div
          style={{
            margin: "20px 0",
            display: "flex",
            justifyContent: "center",
            gap: "40px",
          }}
        >
          <label
            style={{
              display: "flex",
              alignItems: "center",
              gap: "8px",
              fontSize: "16px",
              color: "#1A202C",
            }}
          >
            <input
              type="radio"
              value="approve"
              checked={action === "approve"}
              onChange={() => setAction("approve")}
              style={{
                width: "20px",
                height: "20px",
                accentColor: "#00C4B4",
              }}
            />
            Approve
          </label>
          <label
            style={{
              display: "flex",
              alignItems: "center",
              gap: "8px",
              fontSize: "16px",
              color: "#1A202C",
            }}
          >
            <input
              type="radio"
              value="reject"
              checked={action === "reject"}
              onChange={() => setAction("reject")}
              style={{
                width: "20px",
                height: "20px",
                accentColor: action === "reject" ? "red" : "#00C4B4",
              }}
            />
            Reject
          </label>
        </div>

        <div style={{ marginBottom: "20px" }}>
          <label
            style={{
              display: "block",
              textAlign: "left",
              fontSize: "16px",
              color: "#1A202C",
            }}
          >
            Remark <span style={{ color: "red" }}>*</span>
          </label>
          <textarea
            placeholder="Enter your remarks here..."
            value={adminRemark}
            onChange={handleRemarkChange}
            style={{
              width: "100%",
              height: "100px",
              border: "1px solid #00C4B4",
              borderRadius: "10px",
              padding: "5px",
              boxSizing: "border-box",
              fontSize: "14px",
              color: "#A0AEC0",
            }}
          />
          {error && (
            <p
              style={{
                color: "red",
                fontSize: "14px",
                textAlign: "left",
                marginTop: "5px",
              }}
            >
              {error}
            </p>
          )}
        </div>

        <div style={{ display: "flex", justifyContent: "center", gap: "10px" }}>
          <button
            onClick={handleClose}
            style={{
              padding: "10px",
              width: "120px",
              border: "1px solid #00C4B4",
              borderRadius: "20px",
              backgroundColor: "white",
              color: "#00C4B4",
              cursor: "pointer",
              fontSize: "16px",
            }}
          >
            Cancel
          </button>
          <button
            onClick={onSubmit}
            style={{
              padding: "10px",
              width: "120px",
              border: "none",
              borderRadius: "20px",
              backgroundColor: "#0dcaf0",
              color: "white",
              cursor: "pointer",
              fontSize: "16px",
              transition: "background-color 0.3s, color 0.3s, border 0.3s",
            }}
            onMouseEnter={(e) => {
              e.target.style.backgroundColor = "white";
              e.target.style.color = "#0dcaf0";
              e.target.style.border = "1px solid #0dcaf0";
            }}
            onMouseLeave={(e) => {
              e.target.style.backgroundColor = "#0dcaf0";
              e.target.style.color = "white";
              e.target.style.border = "none";
            }}
          >
            Submit
          </button>
        </div>
      </div>
    </div>
  );
};

export default FranchiseMaster;
